import Box from '@mui/material/Box';

/**
 * The product's own icon (docs/annova-erp-plus-icon-pack, served from /icons): beside the product
 * name in the sidebar and on the sign-in and sign-up pages, and wherever an organisation has no logo.
 */
export default function ProductMark({ size = 34 }: { size?: number }) {
  const src = size > 64 ? '/icons/icon-192.png' : size > 32 ? '/icons/icon-128.png' : '/icons/icon-64.png';
  return <Box component="img" src={src} alt="" width={size} height={size} sx={{ width: size, height: size, flexShrink: 0, display: 'block' }} />;
}
